export default __webpack_public_path__ + "static/barfplan-blog-promo-small@1x-419607c29eb7acbb81ef0ce54ed01e70.webp";